<template>
  <div class="integrate">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部" name="first"></el-tab-pane>
      <el-tab-pane label="收入" name="second"></el-tab-pane>
      <el-tab-pane label="支出" name="third"></el-tab-pane>
    </el-tabs>
    <div class="price">
      <i class="el-icon-coin"></i> 当前共有积分：<span style="color: #ff5353">{{
        countIntegral || "0"
      }}</span>
    </div>
    <div class="integrate_row" v-for="(item, index) in list" :key="index">
      <div class="box">
        <div class="title">{{ item.source }}</div>
        <div class="text" v-if="item.orders">订单号{{ item.orders }}</div>
      </div>
      <div class="box">
        <div class="red" v-if="item.withdraw == '1'">+{{ item.integral }}</div>
        <div class="title" v-if="item.withdraw == '2'">
          -{{ item.integral }}
        </div>
        <div class="black">{{ parseTime(item.integralTime) }}</div>
      </div>
    </div>
    <div class="none" v-if="total == 0">暂无数据</div>
    <div class="pagination-box" v-if="total > 0">
      <el-pagination
        class="ou-pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="queryParams.pageSize"
        layout="total, prev, pager, next, sizes, jumper, slot"
        :total="total"
      >
        <el-button class="ou-page-go">GO</el-button>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { Integral, IntegralCount } from "@/api/user/order";
export default {
  data() {
    return {
      total: 1,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        source: "",
        orders: "",
        integral: "",
        integral_time: "",
        withdraw: "1",
      },
      activeName: "second",
      list: [],
      countIntegral: "",
    };
  },
  created() {
    this.Integral();
    this.IntegralCount();
  },
  methods: {
    Integral() {
      Integral(this.queryParams).then((res) => {
        if (res.code == 200) {
          this.list = res.rows;
          this.total = res.total;
        }
      });
    },
    IntegralCount() {
      IntegralCount().then((res) => {
        if (res.code == 200) {
          this.countIntegral = res.data;
        }
      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.Integral();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.Integral();
    },
    handleClick(tab) {
      this.queryParams.withdraw = tab.index;
      if (tab.index == "0") {
        this.queryParams.withdraw = "";
      }
      this.Integral();
    },
  },
};
</script>
<style scoped lang="scss">
.integrate {
  position: relative;
  padding: 10px 20px;
  .integrate_row {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-between;
    border-bottom: 1px solid #f2f2f2;
    padding: 15px;
    .box {
      .title {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
      }
      .text {
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      .red {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ff5353;
      }
      .black {
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
  }
  .integrate_row:last-child {
    border-bottom: 1px solid #fff;
  }
  .pagination-box {
    text-align: right;
    margin: 25px 0;
  }
  .price {
    position: absolute;
    right: 25px;
    top: 20px;
  }
}
.none {
  min-height: 300px;
  width: 100%;
  text-align: center;
  line-height: 300px;
}
</style>